// extracted by mini-css-extract-plugin
export default {"wrapper":"WoE7Kft0jaSOLE2jsTaJ","teamMember":"wrUoDg9KAnFh6SfyahBF"};